// internationalization
import type { TFunction } from 'i18next';

import type { DateTime } from 'luxon';
// libraries
import { z } from 'zod';

/** Local option shape used by the node/SEU source-selection UI. */
export type SelectableEnergyTreeNode = {
  id: string;
  type?: string | null;
  label: string;
  hasData: boolean;
};

export function createInitiativeFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('input.required', { ns: 'validation' })),
    description: z.string(),
    energyTreeNodes: z
      .array(z.string())
      .min(1, t('input.required', { ns: 'validation' })),
    baselineStart: z.custom<DateTime | null>().nullable(),
    baselineEnd: z.custom<DateTime | null>().nullable(),
    comparisonStart: z.custom<DateTime | null>().nullable(),
    comparisonEnd: z.custom<DateTime | null>().nullable(),
  });
}

export type InitiativeFormValues = z.infer<
  ReturnType<typeof createInitiativeFormSchema>
>;
